import React from 'react';
import PropTypes from 'prop-types';
import RenderTextField from '../common/RenderTextField';
import Button from '../common/Button';
import { Field, Form, Formik } from 'formik';
import { validateRequiredEmail } from '../../utils//validators';

//TODO check validation
const ResetPasswordForm = ({ onSubmit }) => {
  return (
    <Formik
      enableReinitialize
      initialValues={{ username: '' }}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            autoFocus
            name="username"
            component={RenderTextField}
            fullWidth
            type="text"
            label="Email"
            validate={validateRequiredEmail}
          />
          <div>
            <Button
              onClick={handleSubmit}
              type="submit"
              label="Resetuj"
              disabled={isSubmitting || !dirty}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func,
};

export default ResetPasswordForm;
